import { getLeaseFilter } from './actions/leaseFilter';
import { updateZipcodeQuery, updateOffersAfterZipcodeChange } from './actions/zipcode';
import { ZIPCODE_QUERY_PARAM } from './constants';
import store from './store/store';
import content from './mixins/content';
import { findParam } from './queryParams';

export default function init() {
  const zipcodeParam = findParam(ZIPCODE_QUERY_PARAM);
  const zipcodeCookie = localStorage.getItem('userZipCode');
  const zipcode = zipcodeParam || zipcodeCookie;

  store.dispatch(getLeaseFilter(content.filters.lease));

  if (!zipcodeParam && zipcode) {
    store.dispatch(updateZipcodeQuery({ zipcode }));
  }

  window.addEventListener('zipcodeUpdate', (event) => {
    const zipcodeAvailable = event.detail && event.detail.zipcode;

    if (zipcodeAvailable) {
      store.dispatch(updateOffersAfterZipcodeChange({ zipcode: event.detail.zipcode }));
    }
  });
}
